import React from 'react'
import customRequest from '../../../../helpers/customRequest'
import redirect from '../../../../components/redirect/redirect'
import message from '../../../../components/message/message'
//import shared from '../../../../testing/students/shared'
import BeatLoader from 'react-spinners/BeatLoader'
import { Link } from 'react-router-dom'
import buildQuery from '../../../../helpers/buildQuery'

class Manage extends React.Component
{
    state = {
        permissions: [],
        allChecked: false,
        loading: true
    }
    componentDidMount()
    {
        customRequest.get('/api/students/share')
        .then(({data}) => {
            if (data.valid) {

                if (data.permissions.length > 0) {
                    this.setState({permissions: data.permissions, loading: false})
                } else {
                    return redirect.send("/students", () => {
                        message.error("You do not currently have any students you are sharing to other users.")
                    })
                }
            }
            else {
                message.error("There has been an internal error.")
            }
        })
    }

    render()
    {
        var {permissions, allChecked} = this.state
        return (
            <React.Fragment>
                <h3 class = "subheader-text">Manage Student Sharing</h3>
                {this.state.loading ? 
                <BeatLoader
                        size={10}
                        color={"#123abc"}
                        loading={this.state.loading} />

                        :

                <form class = "form-horizontal form-validate" noValidate method = "get" action = "/students/share/revoke">
                    <ul id = "checkbox-list" class = "list-group text-left">
                        {
                        permissions.map((permission) =>
                        {
                            var permissionName
                            if (permission.read && permission.write)
                                permissionName = "all"
                            else if (permission.read)
                                permissionName = "read"
                            else if (permission.write)
                                permissionName = "write"

                            const standardVariables = buildQuery({ student: permission.student, customer: permission.customer })

                            return(
                            <li class = "list-group-item action-list">
                                <input class = "checkbox-list-item" type = "checkbox" id = {`checkbox-${permission.customer}-${permission.student}`} name = {`permissions[${permission.customer}][]`} value = {permission.student} />
                                
                                <label class = "break-words" role = "button" for = {`checkbox-${permission.customer}-${permission.student}`}><strong>{permission.student}</strong> shared to <strong>{permission.customer}</strong> with <strong>{permissionName}</strong> permissions</label>
                                
                                <span class = "float-right">
                                    <Link to = {`/students/share/edit?${standardVariables}`} class = "action-link">Edit</Link>
                                </span>
                            </li>)

                        })
                        }
                    </ul>
                    
                    <div class = "row mt-3">
                        <div class = "col-12 text-left">
                            <input class = "checkbox-shortcut" type = "checkbox" id = "checkbox-shortcut" checked={allChecked} onChange={() => {
                                var checkboxes = document.getElementsByClassName('checkbox-list-item')
                                for (var checkbox of checkboxes)
                                    checkbox.checked = !allChecked

                                this.setState({allChecked: !allChecked})
                            }} />
                            
                            <label role = "button" for = "checkbox-shortcut">Select all</label>
                        </div>
                    </div>
                    
                    <div class = "row">
                        <div class = "col-12 subheader-text">
                            <span>With selected permissions:</span>
                            
                            <br class = "d-block d-sm-none" />
                            
                            <button type = "submit" name = "revoke" value = "revoke" class = "btn btn-secondary btn-md button-inline">Revoke</button>
                        </div>
                    </div>
                </form>
                }
            </React.Fragment>
        )
    }
}


export default Manage
